import { createRouter, createWebHistory } from 'vue-router'

// Sayfalar
import Home from '@/pages/Home.vue'
import About from '@/pages/About.vue'
import Contact from '@/pages/Contact.vue'
import Translators from '@/pages/Translators.vue'
import Login from '@/pages/Login.vue'
import Register from '@/pages/Register.vue'
import PaymentPage from '@/pages/PaymentPage.vue'
import UserPanel from '@/pages/Panel/UserPanel.vue'
import TranslatorPanel from '@/pages/Panel/TranslatorPanel.vue'
import AdminPanel from '@/pages/Panel/AdminPanel.vue'
import Settings from '@/pages/Settings.vue'
import TranslatorApply from '@/pages/TranslatorApply.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import VerifyEmail from '@/views/VerifyEmail.vue'
// Hizmet Sayfaları


// Teklif ve Başvuru sayfaları
import Quote from '@/pages/Quote.vue'
import Apply from '@/pages/Apply.vue'

const routes = [
  { path: '/', component: Home },
  { path: '/about', component: About },
  { path: '/contact', component: Contact },
  { path: '/translators', component: Translators },
  { path: '/login', component: Login },
  { path: '/register', component: Register },
  { path: '/verify-email', component: VerifyEmail },
  { path: '/forgot-password', component: ForgotPassword },
  { path: '/reset-password', component: ResetPassword },

  // 🔐 Korunan sayfalar
  { path: '/panel/user', component: UserPanel, meta: { requiresAuth: true, role: 'user' } },
  { path: '/panel/translator', component: TranslatorPanel, meta: { requiresAuth: true, role: 'translator' } },
  { path: '/panel/admin', component: AdminPanel, meta: { requiresAuth: true, role: 'admin' } },
  { path: '/settings', component: Settings, meta: { requiresAuth: true } },

  { path: '/odeme/:jobId', component: PaymentPage },
  {
    path: '/sayfa/:slug',
    name: 'SayfaDetay',
    component: () => import('@/views/PageDetail.vue')
  },

    // Hizmet Sayfaları
  { path: '/quote', component: Quote },
  { path: '/apply', component: Apply },
  { path: '/apply/form', component: TranslatorApply },
  {
  path: '/services/:slug',
  name: 'ServicePage',
  component: () => import('@/pages/Services/ServicePage.vue')
}
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})

// Token ve kullanıcıyı al
function getToken() {
  return localStorage.getItem('token')
}
function getUser() {
  const raw = localStorage.getItem('user')
  return raw ? JSON.parse(raw) : null
}

// Global route guard
router.beforeEach((to, from, next) => {
  const token = getToken()
  const user = getUser()

  if (to.meta.requiresAuth) {
    if (!token || !user) {
      return next({ path: '/login', replace: true })
    }

    if (to.meta.role && to.meta.role !== user.role) {
      alert('Bu sayfaya erişim izniniz yok. Sipariş için lütfen normal kullanıcı kaydı oluşturun.')
      return next('/')
    }
  }

  next()
})

export default router
